import api from '@/api/openQuestion'

const state = {

}

const actions = {
  getQuestionTemplateGroupList (context, params) {
    return api.getQuestionTemplateGroupList(params)
  },
  createQuestionTemplateGroup (context, group) {
    return api.createQuestionTemplateGroup(group)
  },
  updateQuestionTemplateGroup (context, { questionId, data }) {
    return api.updateQuestionTemplateGroup(questionId, data)
  },
  createQuestionTemplate (context, question) {
    return api.createQuestionTemplate(question)
  },
  updateQuestionTemplate (context, { questionId, data }) {
    return api.updateQuestionTemplate(questionId, data)
  },
  saveQuestionTemplateTree (context, data) {
    return api.saveQuestionTemplateTree(data)
  },
  moveGroupQuestionTemplate (context, { fromGroup, toGroup, question, moveTo, componentPayload }) {
    return api.moveGroupQuestionTemplate(fromGroup, toGroup, question, moveTo, componentPayload)
  },
  getDefaultQuestionTemplate (context, params) {
    return api.getDefaultQuestionTemplate(params)
  },
  getQuestionUpdateTaskList (context, params) {
    return api.getQuestionUpdateTaskList(params)
  },
  setOptionNextQuestion (context, { jobId, questionId, optionId, data }) {
    return api.setOptionNextQuestion(jobId, questionId, optionId, data)
  },
  removeOptionNextQuestion (context, { jobId, questionId, optionId }) {
    return api.removeOptionNextQuestion(jobId, questionId, optionId)
  },
  getNextQuestion (context, params) {
    return api.getNextQuestion(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
